import React, { Fragment } from 'react'
import SnakeBoard from './SnakeBoard'

const SnakeGame = () => {
  return (
    <Fragment>
      <SnakeBoard />
    </Fragment>
  )
}

export default SnakeGame